import s from '@corratech/pylot-custom-widgets/ExperienceGroup/Experience.module.scss'
import React, { ReactElement, Suspense } from 'react'
import Slider from 'react-slick'
import type { Settings as ReactSlickSettings } from 'react-slick'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useIsArabic } from '@components/common/IsArabic/useIsArabic'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
}

const simplicityLandingSliderSettings = {
    arrows: false,
    speed: 400,
    slidesToScroll: 1,
    slidesToShow: 3,
    draggable: true,
    dots: false,
    fade: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2.5,
                dots: false
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.5,
                dots: false
            }
        }
    ]
} as ReactSlickSettings
const ExperienceGroup = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: { heading, subline },
        children
    } = props

    const enhancedChildren = children?.map((item, index) => {
        item.props.data.childCount = index + 1
        return item
    })

    const isArabic = useIsArabic()

    return (
        <Suspense fallback="">
            <div className={s['landing-page-ooka-simplicity-section']}>
                <span
                    className={s['landing-page-ooka-simplicity-section-label']}
                >
                    {subline}
                </span>
                <h2 className={s['landing-page-ooka-simplicity-section-title']}>
                    {heading}
                </h2>
                <div
                    className={
                        s['landing-page-ooka-simplicity-section-wrapper']
                    }
                    suppressHydrationWarning
                >
                    <PerfectScrollbar
                        style={
                            isArabic
                                ? { direction: 'rtl' }
                                : { direction: 'ltr' }
                        }
                    >
                        <div
                            className={[
                                'ooka-simplicity-scrollbar-wrapper'
                            ].join(' ')}
                        >
                            {enhancedChildren}
                        </div>
                    </PerfectScrollbar>
                </div>
            </div>
        </Suspense>
    )
}
export default ExperienceGroup
